// extracted by mini-css-extract-plugin
export var equalColumn = "_du-0";